import { Directive, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { DeprecatedCalloutService } from './callout.service';

/**
 * @deprecated Use riv-callout instead.
 * @see https://rivethealth.github.io/design-system/?path=/story/lib-modal-callout--example
 */
@Directive({
  selector: '[deprecated-callout]',
})
export class DeprecatedCalloutDirective implements OnInit, OnDestroy {
  constructor(
    private readonly template: TemplateRef<unknown>,
    private readonly calloutService: DeprecatedCalloutService,
  ) {}

  ngOnInit() {
    this.calloutService.add(this.template);
  }

  ngOnDestroy() {
    this.calloutService.remove(this.template);
  }
}
